<template>
  <a-card :loading="loading">
    <a-tabs v-if="!loading" default-active-key="1">
      <a-tab-pane key="1" tab="发布评审列表">
        <a-table v-if="tableData.length > 0" size="middle" :pagination="false" :columns="columns" :data-source="tableData" row-key="release_id" :loading="loading">
          <span slot="creator" slot-scope="text, record">
            <user-profiles :value="[record.creator.user_id]" avatar />
          </span>
          <span slot="releseType" slot-scope="text, record">
            {{ record.release_type.label }}
          </span>
          <span slot="releaseEnv" slot-scope="text, record">
            {{ record.release_env.label }}
          </span>
          <span slot="status" slot-scope="text, record">
            <a-badge :status="releaseStatus[record.status].status" :text="releaseStatus[record.status].label" />
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="onDetail(record)"> 查看 </a>
            <a-divider type="vertical" />
            <a :disabled="modifyPermission(record)" @click="onEdit(record)"> 编辑 </a>
          </span>
        </a-table>
        <div v-else>
          <a-empty
            image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
            :image-style="{
              height: '60px'
            }"
          >
            <span slot="description"> 没有发布评审哦 </span>
          </a-empty>
        </div>
        <div class="create-release">
          <a-button v-if="[0, 1].includes(workflowStatus)" type="primary" icon="plus" @click="onCreate"> 创建发布评审 </a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="测试计划列表">
        <a-table v-if="planTableData.length > 0" :scroll="{ x: 1600 }" :pagination="false" :columns="testPlanColumns" :data-source="planTableData" :loading="loading" row-key="id">
          <span slot="testPlanName" slot-scope="text, record">
            <a-tooltip placement="top" :title="record.name">
              <a class="custom-link" :href="planLink(record)" target="_blank"> {{ record.name }} </a>
            </a-tooltip>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-tag :color="testPlanStatus[record.status].color">{{ testPlanStatus[record.status].label }}</a-tag>
          </span>
          <span slot="progress" slot-scope="text, record">
            <a-progress :percent="record.progress" size="small" style="width: 130px" />
          </span>
          <span slot="casesProgress" slot-scope="text, record">
            <span style="padding-left: 30%">{{ record.finished_cases }}/{{ record.total_cases }}</span>
          </span>
          <span slot="type" slot-scope="text, record">
            {{ record.type ? testPlanTypes[record.type].label : '--' }}
          </span>
          <span slot="handlers" slot-scope="text, record">
            <span v-if="handlers(record).length !== 0">
              <a-popover placement="topLeft">
                <template slot="content">
                  <span v-for="handler in handlers(record)" :key="handler.id">
                    <a-avatar :size="20" :src="handler.avatar_url" /> <span class="nickname">{{ handler.nickname }} </span>
                  </span>
                </template>
                <span slot="title">处理人</span>
                <span v-for="handler in handlers(record)" :key="handler.id">{{ handler.nickname }}; </span>
              </a-popover>
            </span>
            <span v-else> -- </span>
          </span>
          <span slot="startTime" slot-scope="text, record">
            <test-plan-date-edit :data-source="record" item-name="start_time" />
          </span>
          <span slot="endTime" slot-scope="text, record">
            <test-plan-date-edit :data-source="record" item-name="end_time" />
          </span>
          <span slot="creator" slot-scope="text, record">{{ getUser(record.creator) }}</span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { workflowReleaseList } from '@/api/project/workflow';
import { releaseStatus, testPlanTypes, testPlanStatus } from '@/utils/dictionary';
import TestPlanDateEdit from '@/pages/project/testplan/components/TestPlanDateEdit';

const columns = [
  {
    title: 'ID',
    dataIndex: 'release_id',
    key: 'release_id',
    align: 'center',
    minWidth: 60
  },
  {
    title: '标题',
    dataIndex: 'release_title',
    key: 'release_title',
    ellipsis: true
  },
  {
    title: '类型',
    dataIndex: 'relese_type',
    key: 'relese_type',
    align: 'center',
    scopedSlots: { customRender: 'releseType' }
  },
  {
    title: '环境',
    dataIndex: 'relese_env',
    key: 'relese_env',
    align: 'center',
    scopedSlots: { customRender: 'releaseEnv' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 180
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
];
const testPlanColumns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 50,
    // fixed: 'left',
    ellipsis: true
  },
  {
    title: '计划名称',
    width: 120,
    ellipsis: true,
    // fixed: 'left',
    scopedSlots: { customRender: 'testPlanName' }
  },
  {
    title: '状态',
    width: 50,
    // fixed: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 100,
    // fixed: 'left',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '已完成/总数',
    width: 80,
    // fixed: 'left',
    scopedSlots: { customRender: 'casesProgress' }
  },
  {
    title: '测试类型',
    width: 50,
    align: 'center',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '测试负责人',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'handlers' }
  }
  // {
  //   title: '开始时间',
  //   width: 150,
  //   align: 'center',
  //   scopedSlots: {customRender: 'startTime'}
  // },
  // {
  //   title: '结束时间',
  //   width: 150,
  //   align: 'center',
  //   scopedSlots: {customRender: 'endTime'}
  // },
  // {
  //   title: '创建人',
  //   width: 100,
  //   align: 'center',
  //   scopedSlots: {customRender: 'creator'}
  // }
];
export default {
  components: { TestPlanDateEdit },
  props: {
    workflowStatus: {
      type: [String, Number],
      default: null
    },
    planData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      testPlanColumns,
      releaseStatus,
      testPlanTypes,
      testPlanStatus,
      loading: true,
      tableData: [],
      planTableData: [],
      filterForm: {
        workflow_id: parseInt(this.$route.query.workflowId) || null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_number: 1
      }
    };
  },
  computed: {
    modifyPermission() {
      return record => {
        return record.modify_permission.status === false || ![0, 1].includes(this.workflowStatus);
      };
    },
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    handlers() {
      return record => {
        return record.handlers || null;
      };
    },
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    planData: {
      immediate: true,
      handler(val) {
        this.planTableData = val;
      }
    }
  },
  created() {
    this.getWorkflowReleaseList();
  },
  methods: {
    // 获取流水线列表
    getWorkflowReleaseList() {
      this.loading = true;
      workflowReleaseList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:workflow:release:detail',
        query: { releaseId: record.release_id }
      });
    },

    onEdit(record) {
      this.$router.push({
        name: 'page:project:workflow:release:edit',
        query: { releaseId: record.release_id }
      });
    },

    onCreate() {
      this.$router.push({
        name: 'page:project:workflow:release:create',
        query: { workflowId: this.$route.query.workflowId }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
  padding: 16px;
}
.ant-card {
  margin: 16px 0;
}

/deep/.ant-tabs-nav .ant-tabs-tab {
  margin: -16px 32px 0 0;
}
.create-release {
  margin-top: 16px;
  text-align: center;
}
</style>
